import { ElementPosition } from '../../types/arGuides';

export function getElementPosition(selector: string): ElementPosition | null {
  // Puede haber VARIOS nodos con la misma ancla (ej: el mismo botón en el
  // header desktop `hidden md:flex` y en el menú ☰ mobile — el no visible
  // reporta rect 0×0). Se devuelve el primer nodo con rect real.
  const nodes = document.querySelectorAll(selector);
  if (nodes.length === 0) return null;

  for (const element of nodes) {
    const rect = element.getBoundingClientRect();

    // Gemelo oculto de una ancla duplicada (display:none): probar el siguiente
    // nodo. checkVisibility es la señal confiable; jsdom no lo implementa (y
    // sin layout todos los rects son 0×0), así que ahí se conserva el
    // comportamiento anterior de no filtrar.
    if (typeof (element as HTMLElement).checkVisibility === 'function') {
      if (!(element as HTMLElement).checkVisibility()) continue;
    }

    // Elemento totalmente fuera del viewport por ARRIBA o la IZQUIERDA: no es
    // contenido scrolleable, está OCULTO (ej. el drawer del menú mobile cerrado,
    // que sigue en el DOM con -translate-x). Sin este corte, el highlight se
    // dibuja pegado al borde apuntando a la nada. Fuera por abajo/derecha SÍ se
    // devuelve: es contenido al que se llega scrolleando y el box sirve de guía.
    if (rect.right < 0 || rect.bottom < 0) return null;

    // IMPORTANTE: Agregar scroll offset para coordenadas absolutas
    // getBoundingClientRect() devuelve coords relativas al viewport
    // Necesitamos coords relativas al documento para que funcionen con scroll
    return {
      x: rect.left + window.scrollX,
      y: rect.top + window.scrollY,
      width: rect.width,
      height: rect.height
    };
  }

  return null;
}
